import { DataFieldModel } from './data-field.model';
import { ContentLanguagesService } from '../utilities/fi-services/content-languages.service';

export class DataFieldGroupModel {
    Id = 0;
    ChangedOn: string; //ISO 8601 date
    ChangedByUserId = 0;
    ChangedByUserName = '';
    DataFields: DataFieldModel[];
    ObjectType;

    constructor(contentLanguagesService: ContentLanguagesService, data) {
        this.Id = data.Id;
        this.ChangedOn = data.ChangedOn;
        this.ChangedByUserId = data.ChangedByUserId;
        this.ChangedByUserName = data.ChangedByUserName;
        this.ObjectType = data.ObjectType;
        if (data.DataFields) {
            this.DataFields = data.DataFields.map(
                (dataField) => new DataFieldModel(contentLanguagesService, dataField),
            );
        }
    }
}
